<template>
  <section
    class="image-section"
    :class="[
      loading && 'image-section--loading',
      isMobile ? 'image-section--mobile' : 'image-section--desktop',
    ]"
  >
    <div class="featured-image-container">
      <client-only>
        <template v-if="loading">
          <div class="hg-skeleton image-skeleton"></div>
        </template>
        <template v-else-if="imagesDisplay.length > 0">
          <HgDealImageGallery
            :images="imagesDisplay"
            :height="isMobile ? 320 : 520"
            @onHandleScroll="handleGalleryScroll"
          >
          </HgDealImageGallery>
        </template>
      </client-only>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import GtmEventsMixin from '@/mixins/GtmEventsMixin';

export default {
  mixins: [GtmEventsMixin],
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: true,
    },
    featuredImages: {
      type: Array,
      default: () => [],
    },
    accommodationImages: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    hasInteracted: false,
    editorUrl: '',
    imagesDisplay: [],
  }),

  computed: {
    ...mapGetters({
      isInternalUser: 'auth/isInternalUser',
    }),

    ...mapState({
      selectedDeal: state => state.selectedDeal,
    }),

    images() {
      const images = [];
      if (!this.selectedDeal) return images;
      if (!this.featuredImages) return images;

      // Featured Images // TODO: Filter by Providers
      // const filteredFeaturedImages = this.filterImages(this.featuredImages);
      // images = images.concat(filteredFeaturedImages);

      this.featuredImages.forEach(image => {
        images.push(image.image);
      });

      // Accommodation Images
      if (!this.accommodationImages || !this.accommodationImages.forEach)
        return images;

      // const filteredAccommodationImages = this.filterImages(
      //   this.accommodationImages,
      // );
      // images = images.concat(filteredAccommodationImages);

      this.accommodationImages.forEach(image => {
        images.push(image.image);
      });

      return images;
    },
  },

  watch: {
    featuredImages() {
      this.imagesDisplay = this.images;
    },
  },

  created() {},

  mounted() {
    this.imagesDisplay = this.images;
  },

  methods: {
    filterImages(images) {
      const filteredImages = [];

      images.forEach(({ image }) => {
        if (!image.allowedProviders.length) {
          filteredImages.push(image);
        } else {
          this.selectedDeal.provider.forEach(provider => {
            if (image.allowedProviders.includes(provider)) {
              filteredImages.push(image);
            }
          });
        }
      });

      return filteredImages;
    },
    handleGalleryScroll() {
      if (!this.hasInteracted) {
        this.hasInteracted = true;

        this.$gtm.push({
          event: 'dealpage_image_slider_used',
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.image-section {
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  overflow: hidden;
  background-color: $teal-40;
  position: relative;
}

.featured-image-container {
  max-width: 1920px;
  margin: 0 auto;
}

.image-section--mobile {
  min-height: 320px;
  height: 320px;
}

.image-section--desktop {
  min-height: 520px;
  height: 520px;
}

@media screen and (min-width: 768px) {
  .image-section {
    min-height: 520px;
    height: 520px;
  }
}

.image-section--loading {
  background-color: $gray-200;
}

.image {
  height: 420px;
}

.image-skeleton {
  height: 100%;
  width: 100%;
}
</style>
